import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { LoginService } from '../services/login.service';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html'
})

export class LoginComponent {
	email: string = "";
	password: string = "";
	authenticationError: boolean = false;
	accessExpired: boolean = false;
    accessExpiredMessage: string = '';

	constructor(
		private router: Router,
		private loginService: LoginService,
		private toastr: ToastrService
	) {}

	login() {
		this.authenticationError = false;
		this.accessExpired = false;

		const payload = {
			username: this.email,
			password: this.password,
			grant_type: environment.grantType,
			client_id: environment.keycloakClientId,
			client_secret: environment.keycloakClientSecret,
			realm: environment.keycloakRealm,
			scope: environment.scope
		};

		this.loginService.login(payload).then(() => {
			this.authenticationError = false;

			if (this.router.url === '/login') {
				const redirectUrl = sessionStorage.getItem('redirectUrl');
				const inviteProjectId = localStorage.getItem('invite_project_id');
				
				if (redirectUrl) {
					sessionStorage.removeItem('redirectUrl');
					this.router.navigateByUrl(redirectUrl);
				} else if (inviteProjectId) {
					localStorage.removeItem('invite_project_id');
					localStorage.setItem('project_id', inviteProjectId);
					this.router.navigate(['/project/my']);
				} else {
					this.router.navigate(['/home']);
				}
			}
		}).catch((err) => {
			if (err?.error?.code === 'ACCESS_EXPIRED') {
				this.authenticationError = false;
				this.accessExpired = true;
				this.accessExpiredMessage =
					err.error.message || 'Your access has expired. Please contact an administrator.';

				this.toastr.warning(this.accessExpiredMessage, 'Access Expired');
				return;
			}
			this.authenticationError = true;
		});
	}
}
